import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AccountantQuotationsAdditionArea from '../../../components/addQuotaion'
import './style.scss'
const AddAccountantQuotationPage = () => {

    return (
        <Fragment>
            
           <AccountantQuotationsAdditionArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AddAccountantQuotationPage
/* AccountantInvoicesAdditionArea */